/* template */
<template><mpx-view @tap="onClick" aria-label="更多" :role="(isAndroid ? '' : 'button')" :tabindex="(isAndroid ? '0' : '')" class="btn-share"><svg width="15px" height="6px" viewBox="0 0 30 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon"><path fill="#FFFFFF" fill-rule="nonzero" d="M2.16,0 C1.548,0 1.044,0.18 0.648,0.612 C0.216,1.008 0,1.512 0,2.124 C0,2.736 0.216,3.24 0.648,3.672 C1.044,4.068 1.548,4.284 2.16,4.284 C2.772,4.284 3.312,4.068 3.744,3.672 C4.14,3.276 4.356,2.772 4.356,2.124 C4.356,1.512 4.14,1.008 3.744,0.612 C3.312,0.18 2.808,0 2.16,0 Z M14.184,0 C13.572,0 13.068,0.18 12.636,0.612 C12.204,1.008 12.024,1.512 12.024,2.124 C12.024,2.736 12.204,3.24 12.636,3.672 C13.068,4.068 13.572,4.284 14.184,4.284 C14.796,4.284 15.336,4.068 15.768,3.672 C16.164,3.276 16.38,2.772 16.38,2.124 C16.38,1.512 16.164,1.008 15.768,0.612 C15.336,0.18 14.796,0 14.184,0 Z M26.172,0 C25.56,0 25.056,0.18 24.624,0.612 C24.192,1.008 24.012,1.512 24.012,2.124 C24.012,2.736 24.192,3.24 24.624,3.672 C25.056,4.068 25.56,4.284 26.172,4.284 C26.784,4.284 27.288,4.068 27.72,3.672 C28.152,3.276 28.368,2.772 28.368,2.124 C28.368,1.512 28.152,1.008 27.72,0.612 C27.288,0.18 26.784,0 26.172,0 Z"/></svg></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0d755e87"}'>
.btn-share
  height 88rpx
  padding 0 0 0 28rpx
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
  &:focus {
    outline none
  }
.icon
  flex none
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { is } from '@didi/webx-js'

createComponent({
  name: 'BtnShare',
  data: {
    isAndroid: is('android'),
  },
  methods: {
    onClick() {
      this.triggerEvent('share-click')
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "btn_share0d755e87",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
